import React, { useEffect, useState, useMemo, useContext } from "react";
import axios from "axios";
import { useParams, Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import Select from "react-select";
import { Box, Button } from "@mui/material";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import { AppContext } from "../../../context/AppContext";
import CurrencySymbols from "../../../common/CurrencySymbol";

const ItemProfitAbilityByCustomer = (props) => {
  const token = localStorage.getItem("Token");
  const locationid = localStorage.getItem("Location");
  const { CurrencySymbol, FractionDigits, dateFormate } =
    useContext(AppContext);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(7);
  const [customerID, setCustomerID] = useState(0);
  const [custoptions, setCustOptions] = useState([]);

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
    if (event?.value == 1) {
      setStartDate("");
      setEndDate("");
    }
  };

  const customerDropDown = custoptions.map((option) => ({
    value: option.Id,
    label: option.CompanyName,
    address: option.Address1,
    email: option.Email,
    address2: option.Address2,
    City: option.City,
    StateProvince: option.StateProvince,
    Country: option.Country,
    PhoneNumber: option.PhoneNumber,
  }));

  const handleChangeCustomer = (event) => {
    setCustomerID(event?.value);
  };

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedDate======>", res);
        setSelectedDate(res.data.ResponseData);
        // setLoading(false);
        return res;
      });

    // customer drop down
    axios
      .get(`${config.customersBaseUrl}/customers/customerdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
          Authorization: token,
        },
      })
      .then((response) => {
        setCustOptions(response.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const callback = (payload, enddate2) => {
    setStartDate(payload);
    setEndDate(enddate2);
  };

  const totalFooterRow = {
    Customername: "Total",
    Amountline: totalSum,
  };

  const augmentedData = [...responseData, totalFooterRow];

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  const uniqueStatusValues = useMemo(
    () => [
      ...new Set(responseData?.map((item) => item.Status).filter(Boolean)),
    ],
    [responseData]
  );
  const apicall = () => {
    setLoading(true);
    axios
      .get(
        `${config.reportsBaseUrl}/reports/itemprofitabilitybycustomer?filtercolumnsearchtext=&currentorder=&ordercolumn=&pagesize=0&pagenumber=0&filtertext=&startdate=${startdate}&enddate=${enddate}&locationid=${locationid}&customerid=${customerID}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          const data = res.data.ResponseData;
          const FilterData = data?.map((el) => ({
            ...el,
            CostPrice: Number(el?.CostPrice),
            OpenBalance: Number(el?.OpenBalance) || 0,
            Profit: Number(el?.Profit) || 0,
            InvoiceNo: el?.InvoiceNo ? Number(el?.InvoiceNo) : "",
            InvoiceDate: moment(el?.InvoiceDate).format("MM/DD/YYYY"),
            DueDate: moment(el?.DueDate).format("MM/DD/YYYY"),
          }));
          setResponseData(FilterData);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        return;
      });
  };

  //---------------------Material React Table------------------//
  const columns = useMemo(() => [
    {
      header: "Product/Service",
      accessorKey: "ItemName",
    },
    {
      header: "Customer",
      accessorKey: "CustomerName",
    },
    {
      header: "Transaction id",
      accessorKey: "SaleId",
    },
    {
      header: "Product Variation Name",
      accessorKey: "ItemVariationName",
    },
    {
      header: "Num",
      accessorKey: "PosId",
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={{
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            fontWeight: "700",
          }}
          onClick={() => {
            const url = `/sales-receipt/${row.original.PosId}`;
            window.open(url, "_blank"); // Open in a new tab
          }}
        >
          {row.original.PosId}
        </Box>
      ),
    },
    {
      header: "Profit",
      accessorKey: "Profit",
      Cell: ({ row }) => {
        return (
          <div style={{ textAlign: "end" }}>
            {CurrencySymbols(
              Number(row?.original?.Profit),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
      AggregatedCell: ({ cell, table }) => {
        const groupingColumnId = cell.row.groupingColumnId ?? "";
        const originalValue =
          cell.row.original?.[groupingColumnId] ??
          cell.row.subRows?.[0]?.original?.[groupingColumnId];

        // Retrieve the aggregated value
        const aggregatedValue = cell.getValue();

        // Check if the value is valid and format it
        const formattedValue =
          typeof aggregatedValue === "number" ? aggregatedValue : 0;

        return (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total for {originalValue ?? "Unknown"}:
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {CurrencySymbols(
                Number(formattedValue),
                { CurrencySymbol },
                FractionDigits
              )}
            </Box>
          </>
        );
      },
    },
    {
      header: "Sale Item Total",
      accessorKey: "SalePrice",
      Cell: ({ row }) => {
        return (
          <div style={{ textAlign: "end" }}>
            {CurrencySymbols(
              Number(row?.original?.SalePrice),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
    },
    {
      header: "Sale Total",
      accessorKey: "SaleTotal",
      Cell: ({ row }) => {
        return (
          <div style={{ textAlign: "end" }}>
            {CurrencySymbols(
              Number(row?.original?.SaleTotal),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
    },
    {
      header: "Open Balance",
      accessorKey: "OpenBalance",
      Cell: ({ row }) => {
        return (
          <div style={{ textAlign: "end" }}>
            {CurrencySymbols(
              Number(row?.original?.OpenBalance),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
      AggregatedCell: ({ cell, table }) => {
        const groupingColumnId = cell.row.groupingColumnId ?? "";
        const originalValue =
          cell.row.original?.[groupingColumnId] ??
          cell.row.subRows?.[0]?.original?.[groupingColumnId];

        // Retrieve the aggregated value
        const aggregatedValue = cell.getValue();

        // Check if the value is valid and format it
        const formattedValue =
          typeof aggregatedValue === "number" ? aggregatedValue : 0;

        return (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total for {originalValue ?? "Unknown"}:
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {/* {formattedValue} */}
              {CurrencySymbols(
                Number(formattedValue),
                { CurrencySymbol },
                FractionDigits
              )}
            </Box>
          </>
        );
      },
    },

    // {
    //   header: "Ledger Amount",
    //   accessorKey: "CostPrice",
    //   Cell: ({ row }) => {
    //     return (
    //       <div style={{ textAlign: "end" }}>
    //         {CurrencySymbols(
    //           Number(row?.original?.OpenBalance),
    //           { CurrencySymbol },
    //           FractionDigits
    //         )}
    //       </div>
    //     );
    //   },
    //   AggregatedCell: ({ cell, table }) => {
    //     const groupingColumnId = cell.row.groupingColumnId ?? "";
    //     const originalValue =
    //       cell.row.original?.[groupingColumnId] ??
    //       cell.row.subRows?.[0]?.original?.[groupingColumnId];

    //     // Retrieve the aggregated value
    //     const aggregatedValue = cell.getValue();

    //     // Check if the value is valid and format it
    //     const formattedValue =
    //       typeof aggregatedValue === "number" ? aggregatedValue : 0;

    //     return (
    //       <>
    //         <Box component="span" sx={{ fontWeight: "bold" }}>
    //           Total for {originalValue ?? "Unknown"}:
    //         </Box>{" "}
    //         <Box
    //           sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
    //         >
    //           {CurrencySymbols(
    //             Number(formattedValue),
    //             { CurrencySymbol },
    //             FractionDigits
    //           )}
    //         </Box>
    //       </>
    //     );
    //   },
    // },
    {
      header: "Due Date",
      accessorKey: "DueDate",
      accessorFn: (originalRow) => moment(originalRow.DueDate),
      filterVariant: "date",
      Cell: ({ row }) =>
        moment(row.original.DueDate).format(`${dateFormate.toUpperCase()}`) ===
        "Invalid date"
          ? ""
          : moment(row.original.DueDate).format(`${dateFormate.toUpperCase()}`),
    },
    // {
    //   header: "Amount",
    //   accessorKey: "SalePrice",
    //   Cell: ({ row }) => {
    //     return (
    //       <div style={{ textAlign: "end" }}>
    //         {CurrencySymbols(
    //           Number(row.original.SalePrice),
    //           { CurrencySymbol },
    //           FractionDigits
    //         )}
    //       </div>
    //     );
    //   },
    // },
    {
      header: "Status",
      accessorKey: "Status",
      filterSelectOptions: uniqueStatusValues, // ["paid", "unpaid"],
      filterVariant: "multi-select", //"select",
      enableColumnFilterModes: false,
    },

    {
      header: "Account Name",
      accessorKey: "AccountName",
    },
    {
      header: "Account Type",
      accessorKey: "AccountType",
    },
    {
      header: "Total Quantity",
      accessorKey: "TotalQuantity",
      Cell: ({ row }) => {
        return (
          <div style={{ textAlign: "end" }}>
            {Number(
              row.original.TotalQuantity ? row.original.TotalQuantity : 0
            ).toFixed(2)}
          </div>
        );
      },
    },
    // {
    //   header: "Profit",
    //   accessorKey: "Profit",
    //   Cell: ({ row }) => {
    //     return (
    //       <div style={{ textAlign: "end" }}>
    //         {CurrencySymbols(
    //           Number(row.original.Profit),
    //           { CurrencySymbol },
    //           FractionDigits
    //         )}
    //       </div>
    //     );
    //   },
    // },
    // {
    //   header: "Sale Time",
    //   accessorFn: (originalRow) => moment(originalRow.Saletime),
    //   filterVariant: "date",
    //   Cell: ({ row }) =>
    //     moment(row.original.Saletime).format("MM/DD/YYYY") === "Invalid date"
    //       ? ""
    //       : moment(row.original.Saletime).format("MM/DD/YYYY"),
    // },
  ]);

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title">Sales By Customer Detail</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Item Profitability By Customer
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Report period
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    //   defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    // isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={reportdropdown.find(
                      (el) => el?.value === selectReport
                    )}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            {selectReport !== 1 && (
              <div className="col-sm-3">
                {/* <div className="row"> */}
                  <ReportDate
                    callback={callback}
                    selectReport={selectReport}
                    showhidecomponent={
                      selectReport == 2 ||
                      selectReport == 3 ||
                      selectReport == 4 ||
                      selectReport == 5 ||
                      selectReport == 6 ||
                      selectReport == 7 ||
                      selectReport == 8 ||
                      selectReport == 9 ||
                      selectReport == 10 ||
                      selectReport == 11 ||
                      selectReport == 12 ||
                      selectReport == 13 ||
                      selectReport == 14 ||
                      selectReport == 15 ||
                      selectReport == 16 ||
                      selectReport == 17 ||
                      selectReport == 18 ||
                      selectReport == 19 ||
                      selectReport == 20 ||
                      selectReport == 21 ||
                      selectReport == 22 ||
                      selectReport == 23 ||
                      selectReport == 24 ||
                      selectReport == 25 ||
                      selectReport == 26 ||
                      selectReport == 27 ||
                      selectReport == 28 ||
                      selectReport == 29 ||
                      selectReport == 30 ||
                      selectReport == 31
                        ? true
                        : false
                    }
                  />
                {/* </div> */}
              </div>
            )}
            <div className="col-sm-3">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Customer
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    onChange={(event) => {
                      handleChangeCustomer(event);
                    }}
                    value={customerDropDown.find((e) => e.value === customerID)}
                    options={customerDropDown}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    isClearable={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    className="custom-search-select mt-1"
                    filterOption={(candidate, input) => {
                      const searchText = input.toLowerCase();
                      const {
                        label,
                        address,
                        PhoneNumber,
                        address2,
                        City,
                        StateProvince,
                        Country,
                      } = candidate.data; // Access additional fields
                      return (
                        label.toLowerCase().includes(searchText) || // Search by name
                        address?.toLowerCase().includes(searchText) || // Search by address
                        PhoneNumber?.toLowerCase().includes(searchText) || // Search by email
                        address2?.toLowerCase().includes(searchText) || // Search by email
                        City?.toLowerCase().includes(searchText) || // Search by email
                        StateProvince?.toLowerCase().includes(searchText) || // Search by email
                        Country?.toLowerCase().includes(searchText) // Search by email
                      );
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-sm-2 align-self-sm-end">
              <button
                type="submit"
                className="btn btn-primary"
                // style={{ marginLeft: "auto" }}
                onClick={() => apicall()}
              >
                Run Report
              </button>
            </div>
          </div>
          {responseData.length > 0 && (
            <div className="card mt-3" id="print">
              <div className="card-body">
                <div className="container">
                  <div className="col-md-12 text-center " id="header">
                    <h6 class="p">SonarPos</h6>
                    <p className="fw-bold p-regular">
                      Item Profitability By Customer
                    </p>
                    <div className="row mb-0">
                      <p>
                        Date:{" "}
                        {startdate === "" && enddate === ""
                          ? "All Data"
                          : moment(startdate).format(
                              `${dateFormate.toUpperCase()}`
                            ) +
                            " - " +
                            moment(enddate).format(
                              `${dateFormate.toUpperCase()}`
                            )}
                      </p>
                    </div>
                  </div>
                </div>
                <hr />
                <div>
                  <CommonMatrialReactTable
                    MainHeading="Sonar POS"
                    ReportHeading="Item Profit Ability By Customer"
                    columns={columns}
                    data={responseData}
                    startdate={startdate}
                    enddate={enddate}
                    columnGrouping={[
                      "ItemName",
                      "ItemVariationName",
                      "CustomerName",
                      "SaleId",
                    ]}
                    columnsVisibility={{
                      TotalQuantity: false,
                    }}
                    enableExpandAll={true}
                    enableExpanding={true}
                    expanded={true}
                    enableRowSelection={false}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ItemProfitAbilityByCustomer;
